import React, { useContext, useEffect, useState, useRef } from "react";
import Footer from "../Footer";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import _ from "lodash";
import UserContext from "../../utils/Contexts/UserContext";
import axiosInstance from "../../utils/Requests/axios";
import toast from "react-hot-toast";
import TablePagination from "../Common/Pagination";
import OrderTable from "./OrderTable";

const Orders = () => {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const [pageCount, setPageCount] = useState(15);
  const [activePage, setActivePage] = useState(1);
  const [columns, setColumns] = useState({
    order: true,
    product: true,
    contracts: true,
    status: true,
    amount: true,
    date: true,
  });
  const allStatuses = [
    { value: null, name: t("All Statuses") },
    { value: 3, name: t("Paid") },
    { value: 1, name: t("Abandoned") },
  ];

  const [activeStatusTab, setActiveStatusTab] = useState(null);

  const handleStatusTabClick = (relValue) => {
    setActiveStatusTab(relValue);
    updateFilter("status", relValue);
  };

  const handleToggle = (column) => {
    setColumns((prevColumns) => ({
      ...prevColumns,
      [column]: !prevColumns[column],
    }));
  };

  const [columnSorts, setColumnSorts] = useState({
    0: null,
    1: null,
    2: null,
    3: null,
    4: "desc",
    5: null,
  });
  const [tableData, setTableData] = useState(null);
  const [recordsFiltered, setRecordsFiltered] = useState(0);
  const [formData, setFormData] = useState({
    draw: 1,
    columns: [
      { data: "code" },
      { data: "product" },
      { data: "status" },
      { data: "amount" },
      { data: "created" },
    ],
    order: [{ column: 4, dir: "desc" }],
    start: 0,
    length: 15,
    search: {
      value: "",
      filters: [],
    },
  });

  useEffect(() => {
    const payload = { ...formData };
    const start = activePage === 1 ? 0 : (activePage - 1) * pageCount;
    if (payload.start !== start || payload.length !== pageCount) {
      payload.start = start;
      payload.length = pageCount;
      setFormData(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, pageCount]);

  const fetchContracts = () => {
    const payload = _.cloneDeep(formData);
    const url = `users/${userData?.uuid}/orders/search`;
    axiosInstance
      .post(url, payload)
      .then((response) => {
        const data = response?.data?.data || [];
        const filtered = response?.data?.recordsFiltered || 0;
        setTableData(data);
        setRecordsFiltered(filtered);

      })
      .catch(() => {
        toast.error(t("There was an error fetching backlinks offers"));
      });
  };

  useEffect(() => {
    const order = Object.keys(columnSorts)
      .filter((columnIndex) => columnSorts[columnIndex])
      .map((columnIndex) => ({
        column: Number(columnIndex),
        dir: columnSorts[columnIndex],
      }));

    if (!_.isEqual(formData.order, order)) {
      setFormData((prev) => ({
        ...prev,
        order,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnSorts]);

  const previousPayloadRef = useRef(null);
  useEffect(() => {
    const payload = { ...formData };
    if (!_.isEqual(previousPayloadRef.current, payload)) {
      previousPayloadRef.current = payload;
      fetchContracts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const updateFilter = (key, value) => {
    setFormData((prevData) => {
      const updatedFilters =
        value === null
          ? prevData.search.filters.filter((filter) => filter.key !== key)
          : [
              ...prevData.search.filters.filter((filter) => filter.key !== key),
              { key: key, value: value },
            ];

      return {
        ...prevData,
        length: 15,
        search: {
          ...prevData.search,
          filters: updatedFilters,
        },
      };
    });
  };

  return (
    <main id="content" role="main" className="main">
      <div className="content container-fluid">
        <div className="page-header" style={{ paddingBottom: "1em" }}>
          <div className="row align-items-center mb-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb breadcrumb-no-gutter">
                <li className="breadcrumb-item">
                  {/* eslint-disable-next-line */}
                  <a href="javascript:;"
                    className="breadcrumb-link"
                    style={{
                      fontSize: "18px",
                      fontWeight: "400",
                      color: "#919293",
                    }}
                  >
                    {t("Wallet")}
                  </a>
                </li>
              </ol>
            </nav>

            <div className="col-md d-md-flex justify-content-between align-items-center mb-sm-2 mb-2 mb-md-0">
              <h1
                className="page-header-title"
                style={{
                  fontSize: "28px",
                  fontWeight: "700",
                }}
              >
                {t("Orders")}
              </h1>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header d-flex flex-wrap justify-content-between gap-2">
            <ul className="nav nav-segment" role="tablist">
              {allStatuses.map((status) => {
                return (
                  <li className="nav-item contract-nav" key={status.value}>
                    <a
                      className={`js-loading-state-invoker nav-link ${
                        activeStatusTab === status.value ? "active" : ""
                      }`}
                      id="nav-one-eg1-tab"
                      data-bs-toggle="pill"
                      href="#nav-one-eg1"
                      role="tab"
                      aria-controls="nav-one-eg1"
                      aria-selected={activeStatusTab === status.value}
                      onClick={(e) => {
                        e.preventDefault();
                        handleStatusTabClick(status.value);
                      }}
                      data-hs-loading-state-options='{
                        "targetEl": "#nav-one-eg1",
                        "removeLoaderDelay": "300"
                      }'
                    >
                      {status.name}
                    </a>
                  </li>
                );
              })}
            </ul>
            <div className="d-grid d-flex justify-content-end align-items-center gap-2">
              <div className="dropdown">
                <button
                  type="button"
                  className="btn btn-white text-nowrap text-secondary order-column-btn"
                  id="showHideDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  data-bs-auto-close="outside"
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    height: "47px",
                    width: "133px !important",
                  }}
                >
                  <i className="bi bi-layout-three-columns me-1 text-secondary"></i>{" "}
                  {t("Columns")}
                </button>

                <div
                  className="dropdown-menu dropdown-menu-end dropdown-card"
                  aria-labelledby="showHideDropdown"
                  style={{ width: "15rem" }}
                >
                  <div className="card card-sm">
                    <div className="card-body">
                      <div className="d-grid gap-3">
                        {Object.keys(columns).map((key) => (
                          <label
                            key={key}
                            className="row form-check form-switch"
                            htmlFor={`toggleColumn_${key}`}
                          >
                            <span className="col-8 col-sm-9 ms-0">
                              <span className="me-2">
                                {t(_.startCase(key))}
                              </span>
                            </span>
                            <span className="col-4 col-sm-3 text-end">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`toggleColumn_${key}`}
                                checked={columns[key]}
                                onChange={() => handleToggle(key)}
                              />
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <OrderTable
            data={tableData}
            columnsVisibility={columns}
            setColumnSorts={setColumnSorts}
            columnSorts={columnSorts}
          />

          <TablePagination
            activePage={activePage}
            setActivePage={setActivePage}
            recordsFiltered={recordsFiltered}
            setPageCount={setPageCount}
            pageCount={pageCount}
          />
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default Orders;
